const cases = [
  {
    img: "https://readdy.ai/api/search-image?query=Neatly%20organized%20clean%20Japanese%20one%20room%20apartment%20interior%20after%20professional%20junk%20removal%2C%20polished%20wooden%20floor%2C%20soft%20window%20light%2C%20warm%20neutral%20tones%2C%20clean%20restored%20room%2C%20editorial%20photography%2C%20simple%20clean%20background%2C%20high%20detail&width=800&height=600&seq=ats-case-01&orientation=landscape",
    area: "京都市中京区",
    type: "不用品回収",
    title: "1Kマンションの引越しに伴う一括回収",
    price: "20,000円",
    time: "作業時間 約1.5時間",
    text: "冷蔵庫・洗濯機・電子レンジ・カラーボックス・ゴミ袋8個など、単身引越しに伴う不用品を軽トラック1台で回収。当日ご依頼から3時間以内に作業完了。",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Peaceful%20tidy%20Japanese%20traditional%20room%20with%20tatami%20mat%20after%20estate%20cleanup%20service%2C%20soft%20natural%20light%20through%20shoji%20window%2C%20calm%20warm%20neutral%20tones%2C%20dignified%20atmosphere%2C%20editorial%20photography%2C%20simple%20clean%20background&width=800&height=600&seq=ats-case-02&orientation=landscape",
    area: "京都市左京区",
    type: "遺品整理",
    title: "戸建ての遺品整理・合同供養",
    price: "185,000円",
    time: "作業時間 約6時間",
    text: "ご遺族様が遠方在住のため、鍵預かりで対応。仏具・写真の合同供養、貴重品の別途仕分け、簡易清掃までワンストップ。",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Clean%20restored%20Japanese%20apartment%20interior%20after%20deep%20cleaning%20service%20from%20cluttered%20state%2C%20polished%20clean%20floor%2C%20fresh%20clean%20atmosphere%2C%20warm%20natural%20light%2C%20warm%20neutral%20tones%2C%20editorial%20photography%2C%20simple%20clean%20background&width=800&height=600&seq=ats-case-03&orientation=landscape",
    area: "京都市山科区",
    type: "ゴミ屋敷清掃",
    title: "3DKアパートのゴミ屋敷清掃・消臭",
    price: "220,000円",
    time: "作業時間 約8時間",
    text: "堆積した生活ゴミ・粗大ゴミを分別搬出、除菌・消臭作業まで完了。オゾン脱臭機による強力消臭で、原状回復レベルまで復旧。",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Empty%20clean%20Japanese%20rental%20apartment%20room%20with%20wooden%20floor%20after%20abandoned%20items%20removal%2C%20soft%20natural%20window%20light%2C%20warm%20neutral%20tones%2C%20clean%20professional%20atmosphere%2C%20editorial%20photography%2C%20simple%20clean%20background&width=800&height=600&seq=ats-case-04&orientation=landscape",
    area: "京都府宇治市",
    type: "残置物撤去",
    title: "賃貸物件の残置物撤去・退去後清掃",
    price: "78,000円",
    time: "作業時間 約4時間",
    text: "不動産会社様からのご依頼。退去後残置物を1日で撤去、写真付き作業報告書を翌日納品。原状回復スケジュールに支障なく完了。",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Empty%20clean%20Japanese%20small%20office%20interior%20after%20office%20relocation%20service%2C%20polished%20floor%2C%20warm%20natural%20light%20through%20window%2C%20clean%20professional%20atmosphere%2C%20warm%20neutral%20tones%2C%20editorial%20photography%2C%20simple%20clean%20background&width=800&height=600&seq=ats-case-05&orientation=landscape",
    area: "京都市下京区",
    type: "オフィス移転",
    title: "小規模オフィスの什器一括処分",
    price: "165,000円",
    time: "作業時間 約5時間",
    text: "デスク8台・チェア10脚・キャビネット・OA機器を一括処分。マニフェスト発行対応、休日夜間作業で業務に支障なく実施。",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Bright%20clean%20empty%20Japanese%20house%20living%20room%20after%20decluttering%20service%2C%20polished%20wooden%20floor%2C%20fresh%20white%20walls%2C%20natural%20sunlight%20streaming%20through%20large%20window%2C%20tidy%20organized%20space%20ready%20for%20sale%20or%20rental%20listing%2C%20no%20furniture%20no%20clutter%2C%20warm%20neutral%20tones%2C%20real%20estate%20photography%20style%20with%20natural%20lighting%2C%20high%20detail%2C%20photorealistic%2C%20editorial%20quality%2C%20simple%20clean%20background&width=800&height=600&seq=ats-case-06-v2&orientation=landscape",
    area: "京都府亀岡市",
    type: "空き家片付け",
    title: "空き家の片付け・売却前整理",
    price: "98,000円",
    time: "作業時間 約5時間",
    text: "長年使われていなかった空き家を片付け、不用品を一括回収しました。家具・家電・生活用品などを丁寧に搬出し、売却や賃貸に向けて室内をすっきりと整理しました。",
  },
];

export default function Cases() {
  return (
    <section id="cases" className="w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-8">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            CASE STUDIES
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            作業事例<span className="text-secondary-500 text-xl md:text-2xl align-middle ml-3">（掲載例）</span>
          </h2>
          <p className="mt-5 text-foreground-600 text-sm md:text-base leading-relaxed">
            京都 不用品回収・京都 遺品整理・京都 ゴミ屋敷清掃のイメージをつかんでいただくための掲載例です。
          </p>
        </div>

        <div className="mb-10 flex items-start gap-3 p-4 rounded-md bg-secondary-100 border border-secondary-200 text-secondary-900 text-xs md:text-sm">
          <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
            <i className="ri-information-2-line"></i>
          </span>
          <p>
            ※以下は実際の作業実績ではなく、内容・料金・所要時間のイメージをお伝えするための<strong>掲載例</strong>です。実際の料金は現地状況により変動しますので、無料お見積りをご利用ください。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {cases.map((c) => (
            <article
              key={c.title}
              className="rounded-lg bg-background-100 border border-background-200 overflow-hidden hover:border-primary-300 transition-colors"
            >
              <div className="relative w-full h-52">
                <img
                  src={c.img}
                  alt={`${c.area} ${c.type} 掲載例`}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-background-50/95 backdrop-blur text-foreground-900 text-xs font-bold">
                  {c.type}
                </span>
                <span className="absolute top-3 right-3 px-2 py-1 rounded-md bg-secondary-500 text-background-50 text-[10px] font-bold tracking-wider">
                  掲載例
                </span>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-2 text-xs text-foreground-500 mb-2">
                  <i className="ri-map-pin-line"></i>
                  <span>{c.area}</span>
                  <span className="w-px h-3 bg-background-300 mx-1"></span>
                  <i className="ri-time-line"></i>
                  <span>{c.time}</span>
                </div>
                <h3 className="text-lg font-bold text-foreground-950 mb-3 leading-snug">
                  {c.title}
                </h3>
                <p className="text-foreground-700 text-sm leading-relaxed mb-4">
                  {c.text}
                </p>
                <div className="flex items-end justify-between pt-4 border-t border-background-200">
                  <span className="text-xs text-foreground-500">掲載例料金</span>
                  <span className="font-mincho text-2xl font-bold text-primary-600">
                    {c.price}
                    <span className="text-xs text-foreground-500 ml-1">(税込)</span>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}